import { extendTheme } from "@chakra-ui/react";
import { brandConfig } from "./brandConfig";

/**
 * Centralized Chakra UI Theme Configuration
 *
 * This theme file integrates brandConfig fonts and ensures consistent typography
 * across the entire application.
 */

const theme = extendTheme({
  // Color mode configuration
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },

  // Typography configuration from brandConfig
  fonts: {
    heading: brandConfig.fonts.heading,
    body: brandConfig.fonts.body,
  },

  // Global styles — force light appearance as the baseline for the client site.
  // Dark-bg sections (navy hero, gray.800 CTAs) use explicit bg+color props
  // so they are unaffected. This prevents Chakra dark-mode localStorage from
  // making text invisible on white-background cards.
  styles: {
    global: {
      body: {
        fontFamily: brandConfig.fonts.body,
        bg: "white",
        color: "#1A202C",
      },
      "h1, h2, h3, h4, h5, h6": {
        fontFamily: brandConfig.fonts.heading,
      },
    },
  },

  // Component-specific overrides
  components: {
    Heading: {
      baseStyle: {
        fontFamily: brandConfig.fonts.heading,
      },
    },
    Text: {
      baseStyle: {
        fontFamily: brandConfig.fonts.body,
      },
    },
    Button: {
      baseStyle: {
        fontFamily: brandConfig.fonts.body,
      },
    },
  },
});

export default theme;
